import React, { useEffect, createContext, useState } from 'react';
import { Header } from './Components/Header';
import { NavigationTabs } from './Components/NavigationTabs';
import { GAtrack } from './Utils/tracking';
import TagManager from 'react-gtm-module';
import { dataFetcher } from './Utils/dataFetcher';
import { useTranslation } from 'react-i18next';
import './App.scss';
import { CosmosMode } from './cosmos/web-scoped/react';

const AppContext = createContext({ loading: true });
const AdContext = createContext({});

let WindowEvent;

/**
 * App
 *
 * @returns {JSX.Element}
 * @constructor
 */
function App() {
  const [config, setConfig] = useState({});
  const [inView, setInView] = useState(false);
  const [adInfos, setAdInfos] = useState({});
  const [data, setData] = useState({});
  const [spoiler, setSpoiler] = useState(false);
  const [spoilerResults, setSpoilerResults] = useState(false);
  const [spoilerKO2, setSpoilerKO2] = useState(false);
  const [lang, setLang] = useState({});
  const { i18n } = useTranslation();

  const changeAdInfos = (newInfo) => {
    setAdInfos({ ...adInfos, ...newInfo });
  };

  useEffect(() => {
    WindowEvent = window.addEventListener(
      'message',
      (message) => {
        if (message.data.open === true) {
          setInView(true);
          setTimeout(() => {
            message.source.postMessage(
              { height: document.documentElement.scrollHeight },
              message.origin
            );
            console.log(document.documentElement.scrollHeight);
            setInView(false);
          }, 1000);
        }
      },
      false
    );
    const url = new URLSearchParams(document.location.search);
    const param = url.get('locale');
    GAtrack({
      event: 'init-meta',
      platform: 'web',
      brand: 'redbull.com', //hardcoded - Do not change
      environment: 'on-site', //hardcoded - Do not change
      language: null !== param ? param : 'en', // we get this data from URLSearchParams "locale"
      locale: null, // we don't get this data
      property_name: 'Red Bull - BQ Master Rollup', //hardcoded - Do not change
      site_type: 'website' //hardcoded - Do not change
    });
    fetch('./app-config.json', { method: 'GET' })
      .then((data) => data.json())
      .then((json) => {
        const tagManagerArgs = {
          gtmId: json.tagManagerId
        };

        TagManager.initialize(tagManagerArgs);

        if (json.hasOwnProperty('uriLang')) {
          const url = new URLSearchParams(document.location.search);
          const param = url.get('locale');

          async function setlang() {
            const locale = param !== null || undefined || '' ? param : 'en';
            const lang = await dataFetcher(json['uriLang'].replace('{locale}', locale));
            i18n.addResourceBundle(locale, 'translation', lang);
            i18n.changeLanguage(locale);

            // let dataLayer = window.dataLayer || [];
            // GAtrack({
            //   event: 'init-meta',
            //   platform: 'web',
            //   brand: 'redbull.com', //hardcoded - Do not change
            //   environment: 'on-site', //hardcoded - Do not change
            //   language: locale, // we get this data from URLSearchParams "locale"
            //   locale: null, // we don't get this data
            //   property_name: 'Red Bull - BQ Master Rollup', //hardcoded - Do not change
            //   site_type: 'website' //hardcoded - Do not change
            // });
          }
          setlang();
        }
        if (!json.hasOwnProperty('animation')) {
          json.animation = {};
        }

        if (!json.animation.hasOwnProperty('duration')) {
          json.animation.duration = 0.36;
        }
        if (!json.animation.hasOwnProperty('ease')) {
          json.animation.ease = [0.35, 0, 0, 1];
        }
        if (json.hasOwnProperty('data')) {
          const { mode, spoilerOverlay } = json.data;
          if (mode === 'archive' && spoilerOverlay) {
            setSpoiler(true);
            setSpoilerKO2(true);

            const resultModule = json.modules.find((e) => e.type === 'results');
            if (resultModule) {
              if (resultModule.lists[0].type !== 'start') {
                setSpoilerResults(true);
              }
            }
          }
          if (mode === 'live') {
            setSpoiler(false);
          }
          setData(json.data);
        }
        if (json.hasOwnProperty('lang')) {
          setLang(json.lang);
        }
        setConfig(json);
      })
      .catch(console.error);

    return () => {
      window.removeEventListener('message', WindowEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="app standalone">
      <AppContext.Provider
        value={{
          config: config,
          loading: Object.keys(config).length === 0,
          inView: inView,
          lang: lang,
          spoiler: spoiler,
          setSpoiler: setSpoiler,
          data: data,
          spoilerResults: spoilerResults,
          setSpoilerResults: setSpoilerResults,
          spoilerKO2: spoilerKO2,
          setSpoilerKO2: setSpoilerKO2
        }}
      >
        <AppContext.Consumer>
          {({ loading }) => {
            if (loading) return <>loading...</>;

            return (
              <CosmosMode mode="dark">
                <AdContext.Provider value={{ adInfos, changeAdInfos }}>
                  {config.modules.length === 1 && config.headline && (
                    <Header title={config.headline} />
                  )}
                  <NavigationTabs modules={config.modules} />
                </AdContext.Provider>
              </CosmosMode>
            );
          }}
        </AppContext.Consumer>
      </AppContext.Provider>
    </div>
  );
}

export { AppContext, AdContext };
export default App;
